var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "video-container"
  }, [_c('div', {
    staticClass: "videoLi",
    class: _vm.returnVideoClass
  }, [_vm.showMoveIcon ? _c('div', {
    staticClass: "checkBox"
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.moveParty
    },
    model: {
      value: _vm.selectPip,
      callback: function ($$v) {
        _vm.selectPip = $$v;
      },
      expression: "selectPip"
    }
  })], 1) : _vm._e(), _c('NewAttendUser', {
    ref: "attendUser",
    attrs: {
      "devicePlatform": _vm.devicePlatform,
      "degreeHost": _vm.degreeHost,
      "singChannel": _vm.singChannel,
      "title": _vm.title,
      "nickName": _vm.nickName,
      "avatar": _vm.avatar,
      "tagName": _vm.tagName,
      "anywherePopShow": _vm.anywherePopShow,
      "theme": _vm.theme,
      "muteVideo": _vm.muteVideo,
      "muteAudio": _vm.muteAudio,
      "showMuteIcons": _vm.singChannel.id == _vm.outputRtilCode ? false : true,
      "needStartVoip": _vm.needStartVoip,
      "userInfo": _vm.userInfo,
      "bookLiveInfos": _vm.bookLiveInfos,
      "volume": _vm.volume,
      "rtcLoaded": _vm.rtcLoaded,
      "selectRid": _vm.selectRid,
      "buttonStatus": _vm.liveInfo.peerId,
      "isAudioLevel": _vm.isAudioLevel,
      "operateList": _vm.btnList,
      "devicesInfo": _vm.devicesInfo,
      "outputRtilCode": _vm.outputRtilCode,
      "liveInfo": _vm.liveInfo,
      "rtc": _vm.rtc,
      "sourceType": _vm.sourceType,
      "leftRightRtilCode": _vm.leftRightRtilCode,
      "remoteNetWorks": _vm.remoteNetWorks,
      "hearSelf": _vm.hearSelf
    },
    on: {
      "callback": _vm.attendCallback
    }
  }, [!_vm.singChannel.id ? _c('div', {
    staticClass: "defaultBox"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoGray
    }
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('mainWindow.noSource')))])]) : _vm._e(), _vm._t("default")], 2), _vm.State.showFootBar ? _c('div', {
    staticClass: "drop-down"
  }, [_c('div', {
    staticClass: "drop"
  }, [!_vm.output ? _c('LiveSourceSelect', {
    ref: `liveSource${_vm.singChannel.rtilCode}`,
    attrs: {
      "slotNum": _vm.slotNum,
      "output": _vm.output,
      "allRList": _vm.receiverList,
      "partyCode": _vm.userInfo.joinCode,
      "useNewUi": true,
      "nickName": _vm.nickName,
      "rtilCode": _vm.singChannel.id,
      "memberId": _vm.singChannel.tid,
      "liveInfo": _vm.liveInfo,
      "bookLiveInfos": _vm.bookLiveInfos,
      "needAudio": _vm.singChannel.shareCode == _vm.singChannel.id ? false : true
    },
    on: {
      "callback": _vm.callbackByLiveSource,
      "setBookLive": _vm.setBookLive
    }
  }) : _c('VfbSelect', {
    attrs: {
      "slotNum": _vm.slotNum,
      "output": _vm.output,
      "devicePeerId": _vm.devicePeerId,
      "outputRtilCode": _vm.outputRtilCode,
      "currentTypeShare": "mainWindow",
      "partyCode": _vm.userInfo.realPartyCode,
      "partyInfo": _vm.userInfo,
      "nickNameInfo": _vm.behaviorInfo,
      "muteVideoObj": !_vm.State.cameraStatus,
      "mainWindowList": _vm.mainWindowList
    },
    on: {
      "callback": _vm.mainwindowSelectCallback
    }
  })], 1)]) : _vm._e()], 1), _vm.output ? _c('div', {
    staticClass: "deviceIconBox"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.turnTips(!_vm.mute, _vm.$t('operationBtn.speaker')),
      "placement": "top"
    }
  }, [!_vm.mute ? _c('i', {
    staticClass: "iconfont icon-a-V2speakeron",
    on: {
      "click": function ($event) {
        return _vm.setAudio('mute');
      }
    }
  }) : _c('i', {
    staticClass: "iconfont icon-a-V2speakeroff",
    class: {
      disabled: _vm.isMute
    },
    on: {
      "click": function ($event) {
        return _vm.setAudio('unmute');
      }
    }
  })])], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };